module.exports = __webpack_public_path__ + "static/fonts/Roboto100.d1e42f1b.ttf";